import { createRouter, createWebHistory } from 'vue-router'
import LoginPage from '@/views/LoginPage.vue'

import IndexPage from '@/views/Home/IndexPage.vue'
import NewTechnicians from '@/views/technicianspage/components/NewTechnicians.vue'
import EditTechnicians from '@/views/technicianspage/components/EditTechnicians.vue'
import DetailTechnicians from '@/views/technicianspage/components/DetailTechnicians.vue'
import MobileStatus from '@/views/technicianspage/components/MobileStatus.vue'
//此处引用文件为大驼峰命名，但源文件为全小写命名，导致编译失败，已按规范修改文件名 Edit by Roshan
import DeleteCheck from '@/views/Librarypage/components/DeleteCheck.vue'
import CheckActive from '@/views/Librarypage/components/CheckActive.vue'
import NewItem from '@/views/Librarypage/components/NewItem.vue'
import EditItem from '@/views/Librarypage/components/EditItem.vue'
import SetValue from '@/views/Librarypage/components/SetValue.vue'
import ItemDetail from '@/views/Librarypage/components/ItemDetail.vue'

const routes = [
  {
    path: '/',
    name: 'Login',
    component: LoginPage,
  },
  {
    path: '/home',
    redirect: '/home/care-orders',
  },
  {
    path: '/home/care-orders/pending-schedule',
    name: 'HmCareOrdersPendingSchedule',
    component: IndexPage,
  },
  {
    path: '/home/care-orders/pending-reschedule',
    name: 'HmCareOrdersPendingReschedule',
    component: IndexPage,
  },
  {
    path: '/home/care-orders/fu-pending-schedule',
    name: 'HmCareOrdersFuPendingSchedule',
    component: IndexPage,
  },
  {
    path: '/home/care-orders/fu-pending-reschedule',
    name: 'HmCareOrdersFuPendingReschedule',
    component: IndexPage,
  },
  {
    path: '/home/care-orders/new',
    name: 'HmCareOrdersNew',
    component: IndexPage,
  },
  {
    path: '/home/care-orders/:orderId/schedule',
    name: 'HmCareOrdersSchedule',
    component: IndexPage,
  },
  {
    path: '/home/care-orders/:orderId/reschedule',
    name: 'HmCareOrdersReschedule',
    component: IndexPage,
  },
  {
    path: '/home/care-orders/:orderId/detail',
    name: 'HmCareOrdersOrderDetail',
    component: IndexPage,
  },
  {
    path: '/home/care-orders/schedule',
    redirect: { name: 'Home' },
  },
  {
    path: '/home/care-orders',
    name: 'Home',
    component: IndexPage,
  },
  {
    path: '/home/library/checklist-items',
    name: 'LibraryChecklistItems',
    component: IndexPage,
  },
  {
    path: '/home/library/care-templates',
    name: 'LibraryCareTemplates',
    component: IndexPage,
  },
  {
    path: '/home/technicians',
    name: 'Technicians',
    component: IndexPage,
  },
  {
    path: '/new-technician',
    name: 'NewTechnician',
    component: NewTechnicians,
  },
  {
    path: '/edit-technician/:id',
    name: 'EditTechnician',
    component: EditTechnicians,
    props: true,
  },
  {
    path: '/detail-technician/:id',
    name: 'DetailTechnician',
    component: DetailTechnicians,
    props: true,
  },
  {
    path: '/update-mobile/:id',
    name: 'UpdateMobile',
    component: MobileStatus,
    props: true,
  },
  {
    path: '/deactivate-user/:id',
    name: 'DeactivateUser',
    component: MobileStatus,
    props: true,
  },
  {
    path: '/delete-check/:id',
    name: 'DeleteCheck',
    component: DeleteCheck,
    props: true,
  },
  { path: '/check-active/:id', name: 'CheckActive', component: CheckActive, props: true },
  {
    path: '/new-checklist-item',
    name: 'NewChecklistItem',
    component: NewItem,
  },
  {
    path: '/edit-checklist-item/:id',
    name: 'EditChecklistItem',
    component: EditItem,
    props: true,
  },
  {
    path: '/set-value/:id',
    name: 'SetValue',
    component: SetValue,
    props: true,
  },
  {
    path: '/item-detail/:id',
    name: 'ItemDetail',
    component: ItemDetail,
    props: true,
  },
]

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes,
})

router.beforeEach((to) => {
  if (to.path.startsWith('/index.php')) {
    return false
  }
  return true // ✅ 添加这一行
})
export default router
